var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "update-waba-channel-form" } },
    [
      _c("a-form", [
        _c(
          "div",
          { staticClass: "form-wrapper" },
          [
            _c(
              "a-alert",
              {
                attrs: {
                  message: _vm.$t("whatsapp_business_api.webhookAddress"),
                  type: "success",
                },
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "description" }, slot: "description" },
                  [
                    _c("div", { staticClass: "webhook-info" }, [
                      _c(
                        "span",
                        [
                          _c("a-icon", {
                            attrs: { type: "copy" },
                            on: { click: _vm.copyWebhookAddress },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.getWebhookAddress()))]),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("whatsapp_business_api.channelName"))),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t("whatsapp_business_api.channelName"),
                    name: "channelName",
                  },
                  model: {
                    value: _vm.clone.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "name", $$v)
                    },
                    expression: "clone.name",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.debugMode
              ? _c(
                  "div",
                  { staticClass: "input-wrapper" },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("whatsapp_business_api.gupshupApiKeyLabel")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("a-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        placeholder: _vm.$t(
                          "whatsapp_business_api.gupshupApiKeyPlaceholder"
                        ),
                        name: "apiKey",
                      },
                      model: {
                        value: _vm.clone.payload.apiKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone.payload, "apiKey", $$v)
                        },
                        expression: "clone.payload.apiKey",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm.$t("whatsapp_business_api.gupshupAppIdLabel"))
                  ),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "whatsapp_business_api.gupshupAppIdPlaceholder"
                    ),
                    name: "appId",
                  },
                  model: {
                    value: _vm.clone.payload.appId,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.payload, "appId", $$v)
                    },
                    expression: "clone.payload.appId",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm.$t("whatsapp_business_api.gupshupAppNameLabel"))
                  ),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "whatsapp_business_api.gupshupAppNamePlaceholder"
                    ),
                    name: "appName",
                  },
                  model: {
                    value: _vm.clone.payload.appName,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.payload, "appName", $$v)
                    },
                    expression: "clone.payload.appName",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm.$t("whatsapp_business_api.phoneNumberE164"))
                  ),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "whatsapp_business_api.phoneNumberE164"
                    ),
                    name: "phoneNumber",
                  },
                  model: {
                    value: _vm.clone.payload.phoneNumber,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.payload, "phoneNumber", $$v)
                    },
                    expression: "clone.payload.phoneNumber",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c(
                  "div",
                  { staticClass: "mt-1 mb-1" },
                  [
                    _c("a-switch", {
                      attrs: { checked: !!_vm.clone.forward.story },
                      on: { click: _vm.toggleChatbot },
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "👉 " +
                          _vm._s(
                            _vm.$t("whatsapp_business_api.forwardToChatbot")
                          )
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("whatsapp_business_api.forwarding"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    attrs: {
                      defaultValue: null,
                      notFoundContent: _vm.$t(
                        "whatsapp_business_api.forwardLiveAgents"
                      ),
                      disabled: !_vm.showStories,
                    },
                    on: { change: _vm.handleStoryChange },
                    model: {
                      value: _vm.clone.forward.story,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone.forward, "story", $$v)
                      },
                      expression: "clone.forward.story",
                    },
                  },
                  [
                    _c(
                      "a-select-option",
                      { attrs: { selected: true, value: null } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$t("whatsapp_business_api.forwardLiveAgents")
                            )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.stories, function (story) {
                      return _c(
                        "a-select-option",
                        { key: story._id, attrs: { value: story._id } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(story.title) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c("a-button", { on: { click: _vm.handleCancel } }, [
              _vm._v(_vm._s(_vm.$t("message.cancel"))),
            ]),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "pr-confirm-btn",
                attrs: { type: "primary", disabled: _vm.loading },
                on: { click: _vm.handleSave },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.update")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }